import { useMemo } from "react"

import { commonProperties } from "shared/lib/arrayUtils"

interface UseCommonPropertyArgs<T, K extends keyof T> {
  objects: T[]
  key: K
}

export function useCommonProperty<T, K extends keyof T>({
  objects,
  key
}: UseCommonPropertyArgs<T, K>) {
  return useMemo(() => commonProperties(objects, [key]), [objects, key])
}
